import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { verifyOtp } from "../../api/Auth"; // make sure this function calls your /verify-otp API

const VerifyOtp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState(location.state?.email || "");
  const [otp, setOtp] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleSubmit = async () => {
    setErrorMsg("");
    setSuccessMsg("");

    try {
      const res = await verifyOtp(email, otp);
      setSuccessMsg(res.message || "OTP verified successfully");
      // Navigate to reset password or login after successful verification
      setTimeout(() => {
        navigate("/auth/set-new-password", { state: { email } });
// optional: if reset screen exists
      }, 2000);
    } catch (error) {
      setErrorMsg(error.response?.data?.message || "Invalid OTP");
    }
  };

  return (
    <Col lg="5" md="7">
      <Card className="bg-secondary shadow border-0">
        <CardBody className="px-lg-5 py-lg-5">
          <Form role="form" onSubmit={(e) => e.preventDefault()}>
            <h3 className="text-center mb-4">Verify OTP</h3>

            <FormGroup className="mb-3">
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="ni ni-email-83" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </InputGroup>
            </FormGroup>

            <FormGroup className="mb-3">
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="ni ni-lock-circle-open" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Enter OTP"
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                />
              </InputGroup>
            </FormGroup>

            <div className="text-center">
              <Button color="primary" type="button" onClick={handleSubmit}>
                Verify OTP
              </Button>
            </div>

            {successMsg && (
              <div className="text-success text-center mt-3">{successMsg}</div>
            )}
            {errorMsg && (
              <div className="text-danger text-center mt-3">{errorMsg}</div>
            )}

            <div className="text-center mt-3">
              <a
                href="#back"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/auth/forgot-password");
                }}
              >
                <small>Back to Forgot Password</small>
              </a>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default VerifyOtp;
